/**
 * This const describe all type diligence.
 */
export enum TypeDiligence {
    NOT_CREATED = 'Sin Crear Debida Diligencia',
    CREATED = 'Creada Debida Diligencia',
    APPROVE = 'Aprobada Debida Diligencia',
    REJECT = 'Rechazada Debida Diligencia',
    TO_CREATE = 'Para Crear Nueva Debida Diligencia',
}

/**
 * This enum represent the type documents names to accept for client.
 */
export enum TypeDocumentNames {
    TERMS_CONDITIONS = 'Terminos y Condiciones AEL',
    POLITIC_DATA = 'Politica Tratamiento Datos AEL',
}

/**
 * This enum represent all the steps when the client is registering.
 */
export enum OnboardingStepsUser {
    FIRST = 0,
    SECOND = 1,
    THIRD = 2,
    FOURTH = 3,
    HOME = 5,
    REJECT = 6,
    PLANS = 8,
}

/**
 * Constant to represent the names of the politics that shows in de modal conditions.
 */
export const POLITICS_NAMES: { [key: string]: string } = {
    [TypeDocumentNames.TERMS_CONDITIONS]: 'Términos y Condiciones',
    [TypeDocumentNames.POLITIC_DATA]: 'Política de Tratamiento de Datos Personales',
};
